import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance'; // Import your axiosInstance
import { Button, Container, Row, Col, Form, Alert, ListGroup, Spinner } from 'react-bootstrap';

const PASSWORD = 'At147852!!!'; // Define your password here

const AdvisorChatPage = () => {
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [messages, setMessages] = useState([]);
    const [currentMessageId, setCurrentMessageId] = useState(null);
    const [advice, setAdvice] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false); // State for authentication
    const [inputPassword, setInputPassword] = useState(''); // State for password input

    // Fetch users on component mount and set up polling
    useEffect(() => {
        if (!authenticated) return; // Don't fetch users if not authenticated

        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get('/chat/all-users');
                setUsers(response.data);
            } catch (error) {
                console.error('Error fetching users:', error);
                setError('Failed to load users. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();

        // Polling to refresh user list every 30 seconds
        const intervalId = setInterval(fetchUsers, 30000);
        return () => clearInterval(intervalId); // Clean up interval on component unmount
    }, [authenticated]);

    // Fetch messages when a user is selected and set up polling
    useEffect(() => {
        if (!selectedUserId || !authenticated) return; // Don't fetch messages if not authenticated

        const fetchMessages = async () => {
            try {
                const response = await axiosInstance.get(`/chat/messages/${selectedUserId}`);
                setMessages(response.data);
            } catch (error) {
                console.error('Error fetching messages:', error);
                setError('Failed to load messages. Please try again later.');
            }
        };

        fetchMessages();

        // Polling to refresh messages every 30 seconds
        const intervalId = setInterval(fetchMessages, 30000);
        return () => clearInterval(intervalId); // Clean up interval on component unmount
    }, [selectedUserId, authenticated]);

    // Handle authentication
    const handleAuthenticate = () => {
        if (inputPassword === PASSWORD) {
            setAuthenticated(true);
        } else {
            setError('Incorrect password. Please try again.');
        }
    };

    // Handle sending advice
    const handleReply = async () => {
        setLoading(true);
        try {
            await axiosInstance.post('/chat/send-advice', {
                messageId: currentMessageId,
                userId: selectedUserId, // Include userId in the payload
                advice
            });
            setAdvice('');
            // Refresh messages
            const response = await axiosInstance.get(`/chat/messages/${selectedUserId}`);
            setMessages(response.data);
            setCurrentMessageId(null);
        } catch (error) {
            console.error('Error sending advice:', error);
            setError('Failed to send advice. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!authenticated) {
        return (
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={4}>
                        <h2>Login</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form>
                            <Form.Group controlId="password">
                                <Form.Label>Password:</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={inputPassword}
                                    onChange={(e) => setInputPassword(e.target.value)}
                                />
                            </Form.Group>
                            <Button
                                variant="primary"
                                onClick={handleAuthenticate}
                            >
                                Login
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row>
                <Col md={4}>
                    <h2>Users</h2>
                    {loading ? (
                        <Spinner animation="border" />
                    ) : (
                        <ListGroup>
                            {users.map((user) => (
                                <ListGroup.Item
                                    key={user._id}
                                    action
                                    active={selectedUserId === user._id}
                                    onClick={() => setSelectedUserId(user._id)}
                                >
                                    {user.name}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Col>
                <Col md={8}>
                    {selectedUserId ? (
                        <>
                            <h2>Chat with {users.find(user => user._id === selectedUserId)?.name}</h2>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <div className="message-list">
                                {messages.map((msg) => (
                                    <div key={msg._id} className="message-item">
                                        <p><strong>{msg.sender === 'user' ? 'User' : 'Advisor'}:</strong> {msg.text}</p>
                                        {msg.sender === 'user' && (
                                            <Button
                                                variant="outline-primary"
                                                onClick={() => setCurrentMessageId(msg._id)}
                                            >
                                                Reply
                                            </Button>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {currentMessageId && (
                                <Form>
                                    <Form.Group controlId="advice">
                                        <Form.Label>Write Your Advice:</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={advice}
                                            onChange={(e) => setAdvice(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Button
                                        variant="primary"
                                        onClick={handleReply}
                                        disabled={loading}
                                    >
                                        {loading ? 'Sending...' : 'Send Advice'}
                                    </Button>
                                </Form>
                            )}
                        </>
                    ) : (
                        <p>Select a user to view and respond to their messages.</p>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default AdvisorChatPage;
